import React from 'react';
import PrivateRoute from 'PrivateRoutes';
import { WhatsappTemplate } from './components';

const routes = () => (
  <PrivateRoute exact path="/settings/whatsapp-template" component={WhatsappTemplate} />
);

export default routes;


// WEBPACK FOOTER //
// src/modules/screens/settings/WhatsappTemplate/routes.js